import Vue from "vue";
import Vuex from "vuex";
import Swal from "sweetalert2";
import { db } from "@/firebase";
import {
  query,
  doc,
  where,
  getDoc,
  setDoc,
  collection,
  getDocs,
  orderBy,
  updateDoc,
  serverTimestamp,
} from "firebase/firestore";
import { getFunctions, httpsCallable } from "firebase/functions";
import { getStorage, ref, deleteObject, getDownloadURL, uploadString } from "firebase/storage";
import moment from "moment";
import VueToast from "vue-toast-notification";
import "vue-toast-notification/dist/theme-default.css";
Vue.use(VueToast);
Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    esEditadoNorma: false,
    idEmpresaSeleccionada: "",
    version: "2024-03-22 - 02:00 p.m.",
    urlRegex:
      /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gi,
    /* CLASE NORMA */
    norma: class {
      constructor() {
        return {
          id: "",
          idEmpresa: "",
          general: {
            idTipo: "",
            autoridades: [],
            codigosCIIU: [],
            descripcion: "",
            documento: {
              url: "",
              nombre: "",
              tipo: ""
            },
            estado: {
              condicion: "",
              pregunta: "",
              fecha: "",
              derogadaPor: ""
            },
            fechaAplicacion: "",
            fechaEmision: "",
            fechaInclusion: moment().format("YYYY-MM-DD"),
            numero: 0,
            periodo: 0,
            verificada: false,
          },
          registro: {
            idUsuario: "",
            creacion: serverTimestamp(),
            actualizacion: serverTimestamp(),
            estado: "Creado"
          }
        }
      }
    },
    /* CLASE ARTÍCULO */
    articulo: class {
      constructor() {
        return {
          id: "",
          idNorma: "",
          idAspecto: "",
          actividades: [],
          descripcion: "",
          numero: "",
          responsable: "",
          tipo: "",
          registro: {
            idUsuario: "",
            creacion: serverTimestamp(),
            actualizacion: serverTimestamp(),
            estado: "Creado"
          }
        }
      }
    },
    /* CLASE USUARIO */
    usuario: class {
      constructor() {
        return {
          id: "",
          nombre: "",
          apellido: "",
          ocupacion: "",
          documento: {
            numero: "",
            tipo: "",
          },
          foto: "",
          portada: "",
          fechaNacimiento: "",
          genero: "",
          correo: "",
          password: "",
          preferencias: {
            idEmpresaSeleccionada: "",
            terminosCondiciones: false,
            politicaPrivacidad: false,
            modoOscuro: false,
          },
          telefono: 0,
          ubicacion: {
            pais: "",
            departamento: "",
            ciudad: "",
            coordenadas: {
              latitud: 0,
              longitud: 0,
            },
            direccion: {
              barrio: "",
              tipo: "",
              calle: "",
              numero: {
                campo1: 0,
                campo2: 0,
              },
              complemento: "",
            },
          },
          registro: {
            estado: "Creado",
            metodo: "",
            creacion: serverTimestamp(),
            actualizacion: serverTimestamp(),
          },
        }
      }
    },
    /* CLASE EMPRESA */
    empresa: class {
      constructor() {
        return {
          id: "",
          razonSocial: "",
          logo: "",
          portada: "",
          nit: {
            numero: "",
            nombre: "CASA MATRIZ",
            digitoVerificacion: "",
            consecutivo: 0,
          },
          personeria: "",
          numeroTrabajadores: "",
          regimenTributario: "",
          correo: "",
          linea: "",
          codigosCIIU: [],
          arl: "",
          contacto: "",
          representanteLegal: {
            nombre: "",
            documento: {
              tipo: "",
              numero: "",
            },
            telefono: 0,
            correo: "",
          },
          responsableSGSST: {
            nombre: "",
            documento: {
              tipo: "",
              numero: "",
            },
            telefono: 0,
            correo: "",
          },
          verificada: false,
          ubicacion: {
            direccion: "",
            pais: "",
            departamento: "",
            ciudad: "",
            zona: "",
          },
          registro: {
            idUsuario: "",
            estado: "Creado",
            creacion: serverTimestamp(),
            actualizacion: serverTimestamp(),
          },
        }
      }
    },
    /* CLASE VINCULACIÓN */
    vinculacion: class {
      constructor(privilegios) {
        return {
          id: "",
          idUsuario: "",
          idEmpresa: "",
          idHorario: "",
          idCargo: "",
          modalidad: "",
          estado: "Pendiente",
          privilegios: privilegios.definir(),
          esInvitado: false,
          esPropietario: false,
          esContratista: false,
          registro: {
            idUsuario: "",
            estado: "Creado",
            creacion: serverTimestamp(),
            actualizacion: serverTimestamp(),
          },
        }
      }
    },
    /* IMAGENES GENERALES */
    imagenes: {
      defecto: {
        foto: require('@/assets/img/general_foto_perfil_defecto.webp'),
        portada: require('@/assets/img/general_foto_portada_defecto.webp')
      },
      comunidad: {
        reacciones: {
          excelenteGris: require("@/assets/img/comunidad_icono_reaccion_excelente_gris.webp"),
          excelente: require("@/assets/img/comunidad_icono_reaccion_excelente.webp"),
          wow: require("@/assets/img/comunidad_icono_reaccion_wow.webp"),
          analizando: require("@/assets/img/comunidad_icono_reaccion_analizando.webp")
        },
      },
    },
    /* ARREGLOS */
    arreglos: {
      generales: {
        tipoDocumento: [
          "Cédula de Ciudadanía",
          "Cédula de Extranjería",
          "PEP - Extranjería",
          "Pasaporte"
        ]
      },
      empresas: {
        regimenTributario: [
          "Responsables de IVA",
          "No Responsables de IVA"
        ],
        arl: [
          "ARL AXA COLPATRIA S.A",
          "COLMENA SEGUROS",
          "COMPAÑÍA DE SEGUROS DE VIDA AURORA S.A.",
          "LA EQUIDAD SEGUROS DE VIDA",
          "LIBERTY SEGUROS DE VIDA S.A",
          "MAPFRE SEGUROS",
          "POSITIVA",
          "SEGUROS BOLÍVAR S.A.",
          "SEGUROS DE VIDA ALFA S.A.",
          "ARL SURA"
        ],
        personeria: [
          "Jurídica",
          "Natural"
        ],
        zona: [
          "Urbana",
          "Rural"
        ],
        numeroTrabajadores: [
          "DE 1 A 10 TRABAJADORES",
          "DE 11 A 50 TRABAJADORES",
          "DE 51 TRABAJADORES EN ADELANTE"
        ],
        linea: [
          "CASH",
          "EBC",
          "SECURE",
          "TECHNOLOGY",
          "RISK"
        ]
      }
    },

    async obtenerUsuario(id) {
      let usuario = null;
      const docRef = doc(db, "usuarios", id);
      const docSnap = await getDoc(docRef);
      if (docSnap.exists()) {
        usuario = docSnap.data();
      }
      return usuario;
    },

    async obtenerEmpresa(id) {
      let empresa = null;
      const docRef = doc(db, "empresas", id);
      const docSnap = await getDoc(docRef);
      if (docSnap.exists()) {
        empresa = docSnap.data();
      }
      return empresa;
    },

    async obtenerActividadArticulo(id) {
      let actividad = null;
      const docRef = doc(db, "normas_actividades", id);
      const docSnap = await getDoc(docRef);
      if (docSnap.exists()) {
        actividad = docSnap.data();
      }
      return actividad;
    },

    async obtenerAspectoArticulo(id) {
      let aspecto = null;
      const docRef = doc(db, "normas_aspectos", id);
      const docSnap = await getDoc(docRef);
      if (docSnap.exists()) {
        aspecto = docSnap.data();
      }
      return aspecto;
    },

    async obtenerArticulosNorma(id) {
      let articulos = [];
      const q = query(
        collection(db, "normas_articulos"),
        where("idNorma", "==", id),
        where("registro.estado", "in", ["Creado", "Editado"]),
        orderBy("registro.creacion", "asc")
      );
      const querySnapshot = await getDocs(q);
      querySnapshot.docs.forEach((doc) => {
        articulos.push({
          ...doc.data(),
          ayuda: `
            <b>Artículo N°${doc.data().numero}</b>
            <div style="height: 115px !important; overflow-y: auto !important; overflow-x: hidden !important; max-height: 250px !important;">
                <p style="width: 330px; max-width: 100%; text-align: justify; margin-right: 10px; white-space: pre-line">${doc.data().descripcion}</p>
            </div>
          `
        });
      })
      return articulos;
    },

    async obtenerCodigosCIIU() {
      let codigosCIIU = [];
      const q = query(collection(db, "codigos_CIIU"), orderBy("claseRiesgo", "asc"));
      const querySnapshot = await getDocs(q);
      querySnapshot.forEach((doc) => {
        codigosCIIU.push({
          id: doc.id,
          codigo: doc.data().codigo,
          claseRiesgo: doc.data().claseRiesgo,
          digitoAdicional: doc.data().digitoAdicional,
          descripcion: doc.data().descripcion,
        });
      });
      return codigosCIIU;
    },

    async obtenerTiposNorma() {
      let tipos = [];
      const q = query(collection(db, "normas_tipos"), orderBy("nombre", "asc"));
      const querySnapshot = await getDocs(q);
      querySnapshot.forEach((doc) => {
        tipos.push({
          id: doc.id,
          nombre: doc.data().nombre,
        });
      });
      return tipos;
    },

    async obtenerAspectosNorma() {
      let aspectos = [];
      const q = query(collection(db, "normas_aspectos"), orderBy("nombre", "asc"));
      const querySnapshot = await getDocs(q);
      querySnapshot.forEach((doc) => {
        aspectos.push({
          id: doc.id,
          nombre: doc.data().nombre,
        });
      });
      return aspectos;
    },

    obtenerPeriodosNorma() {
      let periodos = [];
      const contador = new Date();
      for (let index = 1950; index <= contador.getFullYear() + 1; index++) {
        periodos.unshift(index);
      }
      return periodos;
    },

    alternarEditadoNorma() {
      this.esEditadoNorma = true;
      setTimeout(() => {
        this.esEditadoNorma = false;
      }, 1000);
    },

    async obtenerAutoridadesNorma() {
      let autoridades = [];
      const q = query(collection(db, "normas_autoridades"), orderBy("nombre", "asc"));
      const querySnapshot = await getDocs(q);
      querySnapshot.forEach((doc) => {
        autoridades.push({
          id: doc.id,
          nombre: doc.data().nombre,
        });
      });
      return autoridades;
    },

    async esperar(tiempo) {
      return new Promise((resolve) => {
        setTimeout(resolve, tiempo);
      });
    },

    alertaToast(tipo = "success", texto = "", posicion = "top-right") {
      let icono = "checkmark-circle";
      let color = "#fff";
      if (tipo === "error") {
        icono = "alert-circle";
      } else if (tipo === "warning") {
        icono = "warning";
        color = "#222";
      } else if (tipo === "info" || tipo === 'default') {
        icono = "information-circle"
      }
      Vue.$toast.open({
        type: tipo,
        message: `
          <div class="d-flex mt-2">
            <ion-icon name="${icono}" style="font-size: 18pt; margin-right: 2px; color: ${color}"></ion-icon><p class="fw-bold" style="word-break: break-all; font-size: 13px; color: ${color}">${texto}</p>
          </div>
        `,
        position: posicion,
        duration: 3000,
      });
    },

    alerta(tipo = "info", titulo = "", msg = "", error = "") {
      let contenido = "";
      if (tipo == "success" && msg != "") {
        contenido = `
        <div class="p-2 rounded border">
          <p class="text-start"><b>📌 </b>${msg}</p>
        </div>
        `;
      } else if (tipo == "info" && msg != "") {
        contenido = `
        <div class="p-2 rounded border">
          <p class="text-start"><b>📌 </b>${msg}</p>
        </div>
        `;
      } else if (tipo == "warning" && msg != "") {
        contenido = `
        <div class="p-2 rounded border">
          <p class="text-start"><b>📌 </b>${msg}</p>
        </div>
        `;
      } else if (tipo == "question" && msg != "") {
        contenido = `
        <div class="p-2 rounded border">
          <p class="text-start"><b>📌 </b>${msg}</p>
        </div>
        `;
      } else if (tipo == "error") {
        contenido = `
        <div>
          <textarea class="form-control rounded" rows="5" disabled>${error}</textarea><br>
          <p class="text-start"><b>1. </b>Ha ocurrido un error en la operación. Vuelve a intentarlo.</p>
          <p class="text-start"><b>2. </b>Toma captura de pantalla o copia el texto del error para una solución más eficiente.</p>
          <p class="text-start"><b>3. </b>Si el error persiste, comunícate con <a href="javascript:void(0)" class="fw-bold text-dark"><i class="fas fa-envelope-open-text"></i> Soporte Técnico</a></p>
        </div>
        `;
      }
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: "btn btn-primary w-100 fw-bold",
        },
        buttonsStyling: false,
      });
      swalWithBootstrapButtons.fire({
        icon: tipo,
        title: '<h5>' + titulo + "</h5>",
        html: contenido,
        confirmButtonText: "Entendido",
        showConfirmButton: true,
        showCancelButton: false,
        reverseButtons: false,
        allowOutsideClick: false,
        allowEscapeKey: false,
      });
    },

    modificarEstilosTabla() {
      var elementos = document.querySelectorAll(".vgt-input");
      elementos.forEach((elemento) => {
        elemento.classList.remove("vgt-input");
        elemento.classList.add("form-control");
      });
    },

    cerrarModal() {
      /* $(".modal").modal("hide"); */
    },

    async enviarNotificacion(categoria, nombreUsusario, idUsuario, texto) {
      const refNotificacion = doc(collection(db, "notificaciones"));
      this.nuevaNotificacion.id = refNotificacion.id;
      const agregarNotificacion = doc(
        db,
        "notificaciones",
        this.nuevaNotificacion.id
      );
      await setDoc(agregarNotificacion, {
        id: this.nuevaNotificacion.id,
        idUsuario: idUsuario,
        idDestinatarios: [idUsuario],
        categoria: categoria,
        infoEnviada: {
          nombreUsuario: nombreUsusario,
          texto: texto,
          tipo: "image",
          url: "",
        },
        notificacionNoLeida: [idUsuario],
        registro: {
          creacion: serverTimestamp(),
          actualizacion: serverTimestamp(),
        },
      });
    },

    alertaUsuarioSinDatos() {
      Swal.fire({
        icon: "info",
        background: "rgb(255, 245, 231)",
        buttonsStyling: false,
        confirmButtonText: "Entendido",
        customClass: {
          confirmButton:
            "btn btn-primary w-100 text-capitalize h5 font-weight-bold",
        },
        allowOutsideClick: false,
        allowEscapeKey: false,
        position: "center",
        title:
          "<h4 style='color: black; font-weight: bold'>¡Hemos notado que no has completado el proceso de registro en GoodBzz!</h4>",
        html: '<p style="color: rgb(0, 0, 0); font-weight: 400">Requieres completar este proceso para acceder al módulo.</p>',
        showConfirmButton: true,
      }).then(() => {
        window.location.replace("/miperfil");
      });
    },

    async ocultarPublicacionComunidad(id) {
      const publicacionRef = doc(db, "publicaciones", id);
      await updateDoc(publicacionRef, {
        esVisible: false,
        "registro.actualizacion": serverTimestamp(),
      });
    },

    eliminarArchivosTemporales() {
      let archivos = localStorage.getItem("archivosTemporales");
      if (archivos) {
        for (let url of JSON.parse(
          localStorage.getItem("archivosTemporales")
        )) {
          const storage = getStorage();
          const fileRef = ref(storage, url);
          deleteObject(fileRef);
        }
        localStorage.setItem("archivosTemporales", JSON.stringify([]));
      }
    },

    calcularFechaComunidad(date) {
      moment.locale("es-mx");
      let dateConvert;
      let seconds = Math.floor((new Date() - date) / 1000);
      let interval = Math.floor(seconds / 31536000);
      if (interval >= 1) {
        dateConvert = moment(date).format("LL");
      } else {
        interval = Math.floor(seconds / 2592000);
        if (interval >= 1) {
          dateConvert = moment(date).format("DD/MM/YYYY [a las] h:mm A");
        } else {
          interval = Math.floor(seconds / 86400);
          if (interval >= 1) {
            let dateCurrent = moment().format("DD/MM/YYYY");
            let date2 = moment(date).format("DD/MM/YYYY");
            let daysPassed = this.restarFechasComunidad(date2, dateCurrent);
            if (daysPassed <= 2) {
              dateConvert = moment(date).fromNow();
            } else {
              dateConvert = moment(date).format("DD/MM/YYYY [a las] h:mm A");
            }
          } else {
            dateConvert = moment(date).fromNow();
          }
        }
      }
      return dateConvert;
    },

    restarFechasComunidad(f1, f2) {
      let aFecha1 = f1.split("/");
      let aFecha2 = f2.split("/");
      let fFecha1 = Date.UTC(aFecha1[2], aFecha1[1] - 1, aFecha1[0]);
      let fFecha2 = Date.UTC(aFecha2[2], aFecha2[1] - 1, aFecha2[0]);
      let dif = fFecha2 - fFecha1;
      let dias = Math.floor(dif / (1000 * 60 * 60 * 24));
      return dias;
    },

    obtenerLinkTextoComunidad(texto) {
      return texto.replace(this.urlRegex, (url) => {
        return (`<style>.link-post:hover { text-decoration: underline !important }</style> <a class="link-post text-decoration-none" target="_blank" href="${url}">${url}</a>`)
      });
    },

    async obtenerMetadataUrl(url) {
      let metadata = {
        titulo: null,
        descripcion: null,
        tipo: null,
        proveedor: null,
        imagen: null,
        url: null,
      };
      const functions = getFunctions();
      const obtenerMetadata = httpsCallable(functions, "obtenerMetadata");
      await obtenerMetadata({
        url: url,
      }).then((result) => {
        metadata = {
          titulo: result.data.title,
          descripcion: result.data.description,
          tipo: result.data.type,
          proveedor: result.data.provider,
          imagen: result.data.image,
          url: result.data.url,
        };
      });
      return metadata;
    },

    obtenerTipoArchivo(file) {
      let tipo;
      if (file.type.match("image.*")) {
        tipo = "image";
      }
      if (file.type.match("video.*")) {
        tipo = "video";
      }
      if (file.type.match("application/pdf")) {
        tipo = "pdf";
      }
      if (
        file.type.match(
          "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
        )
      ) {
        tipo = "word";
      }
      if (
        file.type.match(
          "application/vnd.openxmlformats-officedocument.presentationml.presentation"
        )
      ) {
        tipo = "powerpoint";
      }
      if (
        file.type.match(
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        )
      ) {
        tipo = "excel";
      }
      return tipo;
    },

    async subirArchivoBase64(referencia, url) {
      const snapshot = await uploadString(referencia, url, 'data_url');
      const urlResult = await getDownloadURL(snapshot.ref);
      return urlResult ? urlResult : null;
    },
  },
  mutations: {},
  actions: {},
  modules: {},
});